import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { DesignProvider } from 'contexts/DesignContext'
import ExternalWidget from 'designer/external/ExternalWidget'

const PcuHeader = () => {
  let patientRouteMatch = useRouteMatch(
    '/pcu-file/:section/:module/:submodule/'
  )
  let params = patientRouteMatch?.params
  if (!patientRouteMatch) {
    return false
  }
  if (!params?.section) {
    return false
  }

  return (
    <React.Fragment>
      <DesignProvider>
        <ExternalWidget widgetCode={`header-pcu`} />
      </DesignProvider>
    </React.Fragment>
  )
}

export default PcuHeader
